import { useNavigate } from 'react-router-dom'
import { FaUserShield, FaArrowLeft, FaCar } from 'react-icons/fa'
import LoginForm from '../components/loginForm'
import '../styles/styles.css'

export default function Login() {
  const navigate = useNavigate()

  const handleLogin = (session) => {
    // Verificar si es admin
    const adminEmails = ['agussourrouille9@gmail.com'];
    const userEmail = session?.user?.email;
    
    if (adminEmails.includes(userEmail)) {
      navigate('/admin-dashboard');
    } else {
      navigate('/empleado');
    }
  }

  const handleBack = () => {
    navigate('/')
  }

  return (
    <div className="login-container">
      <div className="login-card">
        {/* Header */}
        <div className="login-header">
          <button onClick={handleBack} className="back-button">
            <FaArrowLeft />
            Volver
          </button>
        </div>

        {/* Logo y título */}
        <div className="login-logo">
          <div className="logo-icon">
            <FaCar />
          </div>
          <h1>LUBRICENTROS</h1>
        </div>

        {/* Título principal */}
        <div className="login-title-section">
          <div className="user-icon">
            <FaUserShield />
          </div>
          <h2>Acceso al Sistema</h2>
          <p>Ingresa tus credenciales para acceder</p>
        </div>

        {/* Formulario */}
        <LoginForm onLogin={handleLogin} />

        {/* Footer */}
        <div className="login-footer">
          <p>Sistema de gestión de lubricentros</p>
        </div>
      </div>
    </div>
  )
}